import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuDto } from "@/dto/MenuDto";

export default function useMenu() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [expandedMenus, setExpandedMenus] = useState<Record<string, boolean>>(
    {}
  );

  const handleMenuClick = (menu: MenuDto) => {
    if (menu.path) {
      navigate(menu.path);
    }
  };

  const selected = (path?: string) => {
    if (!path) return false;

    console.log("pathname", pathname, "path", path);

    if (path === "/") {
      return pathname === "/";
    }

    return pathname.startsWith(path);
  };

  const toggleExpanded = (menuTitle: string) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuTitle]: !prev[menuTitle],
    }));
  };

  return {
    handleMenuClick,
    selected,
    expandedMenus,
    toggleExpanded,
  };
}
